import React from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import RouteIcon from '@mui/icons-material/Route';
import { Link } from 'react-router-dom';

const Menu_Navegacao = () => {
    return (
        <ButtonGroup variant="contained" size="large" aria-label="Basic button group" color="success">
            <Button 
                startIcon={<LocationOnIcon />} 
                component={Link} 
                to="/logistica"
            >
                Painel
            </Button>
            
            {/* <Button 
                startIcon={<MapIcon />} 
                component={Link} 
                to="/logistica_roteiro"
            >
                Histórico de Trajeto
            </Button> */}
            
            <Button 
                startIcon={<RouteIcon />} 
                component={Link} 
                to="/logistica_planejamento"
            >
                Planejamento
            </Button>
        </ButtonGroup>
    );
}

export default Menu_Navegacao;
